import ImageUtil from '@/js/util/ImageUtil.js'
import ImageRoundClipper from '@/js/ImageRoundClipper.js'

/**
 * キャンバスを作成する
 *
 * @param {Number} width キャンバスの幅
 * @param {Number} height キャンバスの高さ
 * @returns {Canvas} キャンバス要素
 */
const createCanvas = (width, height) => {
  const canvas = document.createElement('canvas')
  canvas.style.display = 'none'
  canvas.width = width
  canvas.height = height
  return canvas
}

/**
 * ピン画像とアイコン画像を合成したイメージオブジェクトを生成
 * @param {*} pinSrc ピン画像ソース
 * @param {*} iconSrc 報告書アイコンソース
 * @returns {Object} 合成したイメージオブジェクトを返却
 */
export async function getIconEmbeddedPin(pinSrc, iconSrc) {
  // ベースとなる画像取得
  const [pinImg, iconImg] = await Promise.all([
    ImageUtil.toImage(pinSrc),
    ImageUtil.toImage(iconSrc),
  ])

  // 作業用 Canvas 生成
  const c = createCanvas(pinImg.width, pinImg.height)
  const ctx = c.getContext('2d')

  // ピン画像を Canvas に描画
  ctx.drawImage(pinImg, 0, 0)

  // アイコン画像をクリップしたimg生成
  const { image: clippedIconUrl } = await ImageRoundClipper.clip(iconImg)
  const clippedIcon = await ImageUtil.toImage(clippedIconUrl)
  clippedIcon.width = 72
  clippedIcon.height = 72

  // クリップした報告書アイコンを重ねて Canvas に描画
  ctx.drawImage(
    clippedIcon,
    c.width / 2 - clippedIcon.width / 2,
    c.height / 2 - clippedIcon.height / 2 - 25,
    clippedIcon.width,
    clippedIcon.height
  )

  return c.toDataURL()
}
